export default __webpack_public_path__ + "static/media/kitchen5-afterE.9d7c59cb.jpg";